import config from "../index";
import theme from "../Theme";
import { createUseStyles } from "react-jss";
import Error from "../Errors";
export default function buildClasses(style, props = {}) {
    if (!config.isInited())
        throw new Error("InitError", "Lib @nodeme/jss-react has not been inited!");
    return createUseStyles(style(theme)(config.getDefinitions()))(props);
}
